import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const DinamicaList = props => <DefaultDataTable data={props} />;
